import React, { useState, useEffect, useCallback } from 'react';
import AddAnnotationModal from './AddAnnotationModal';
import { showAppAlert } from '../utils/alertService';
import '../styles/formStyles.css';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function ClientAnnotationsModal({ client, visible, onClose }) {
  const [annotations, setAnnotations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  useEffect(() => {
    setAnnotations([]);
  }, [visible]);

  const fetchAnnotations = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const user = JSON.parse(localStorage.getItem('user'));

      // Endpoint para buscar anotações por cliente e usuário
      const response = await fetch(`${API_URL}/clients/annotations?client_id=${client.id}&user_id=${user.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setAnnotations(Array.isArray(data) ? data : []);
      } else {
        const errorData = await response.json();
        showAppAlert('error', errorData.message || 'Erro ao buscar anotações.');
        setAnnotations([]);
      }
    } catch (error) {
      console.error('Erro ao buscar anotações:', error);
      showAppAlert('error', 'Ocorreu um erro de rede. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }, [client]);

  useEffect(() => {
    if (visible && client) {
      fetchAnnotations();
    }
  }, [visible, client, fetchAnnotations]);

  const handleAddModalClose = () => {
    setIsAddModalOpen(false);
    fetchAnnotations(); // Recarrega a lista após adicionar uma nova anotação
  };

  if (!visible || !client) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '700px', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexShrink: 0 }}>
          <h3>Anotações de {client.nome}</h3>
          <button onClick={() => setIsAddModalOpen(true)} className="button-style">
            + Adicionar Nova
          </button>
        </div>

        <div style={{ overflowY: 'auto', flexGrow: 1, paddingRight: '10px' }}>
          {loading ? (
            <p>Carregando anotações...</p>
          ) : (
            <div className="annotations-list">
              {annotations.length > 0 ? (
                annotations.map((item, index) => (
                  <div key={index} style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '8px', marginBottom: '10px', backgroundColor: '#f9f9f9' }}>
                    <p style={{ whiteSpace: 'pre-wrap' }}>{item.annotation}</p>
                    <small style={{ color: '#555' }}>
                      Registrado em: {new Date(item.created_at).toLocaleDateString('pt-BR')}
                    </small>
                  </div>
                ))
              ) : (
                <p>Nenhuma anotação encontrada para este cliente.</p>
              )}
            </div>
          )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px', flexShrink: 0 }}>
          <button onClick={onClose} className="button-style cancel">Fechar</button>
        </div>

        <AddAnnotationModal client={client} visible={isAddModalOpen} onClose={handleAddModalClose} />
      </div>
    </div>
  );
}

export default ClientAnnotationsModal;